import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProvider(agro_exporter_id, provider_type, provider_id) {
    return RequesterV1.get(
      `agro_exporter/certifications/providers/manage_certification_reviews/${agro_exporter_id}/fetch_provider/${provider_type}/${provider_id}`
    );
  },

  create(
    agro_exporter_id,
    provider_type,
    provider_id,
    certification_review_params
  ) {
    return RequesterV1.post(
      `agro_exporter/certifications/providers/manage_certification_reviews/${agro_exporter_id}/create/${provider_type}/${provider_id}`,
      { certification_review: certification_review_params }
    );
  },

  destroy(agro_exporter_id, provider_type, provider_id, certification_review_id) {
    return RequesterV1.delete(
      `agro_exporter/certifications/providers/manage_certification_reviews/${agro_exporter_id}/destroy/${provider_type}/${provider_id}/${certification_review_id}`,
    );
  },
}
